/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menulunchsavednotvisible4Inputs */

const en_menulunchsavednotvisible4 = /** @type {(inputs: Menulunchsavednotvisible4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch menu saved`)
};

const de_menulunchsavednotvisible4 = /** @type {(inputs: Menulunchsavednotvisible4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü gespeichert`)
};

/**
* | output |
* | --- |
* | "Lunch menu saved" |
*
* @param {Menulunchsavednotvisible4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menulunchsavednotvisible4 = /** @type {((inputs?: Menulunchsavednotvisible4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menulunchsavednotvisible4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menulunchsavednotvisible4(inputs)
	return de_menulunchsavednotvisible4(inputs)
});
export { menulunchsavednotvisible4 as "menuLunchSavedNotVisible" }